var mm,
mobilemenu = {
	settings: {
		mobileButton: $('#mobile-btn'),
		nav: $('.nav'),
	},
	init: function() {
		mm = this.settings;
		this.bindUIActions();
		console.log('mobile menu loaded!');
	},
	bindUIActions: function() {
		mm.mobileButton.on('click', function(e) {
		    $(this).toggleClass('is-active');
		    mm.nav.toggleClass('is-active');
			console.log('logged');
		});
	}
};
